// extracted by mini-css-extract-plugin
export var modalFooter = "_qc-0";